<div class="cabboton container p-3 my-3 bg-cabimp text-white">
    <button  class="btn btn-cave" (click)="volver()">
      <fa-icon [icon]="icoRet"></fa-icon>  Volver
    </button>
     <button style="margin-left:5px;" class="btn btn-success"  onClick="window.print()">
      <fa-icon [icon]="icoPrn"></fa-icon>  Imprimir
    </button>
</div>
<div style="text-align: center;">
  <div *ngIf="resul" class="spinner-border text-primary" role="status"></div>
</div>

<div class="cuerpo">
   <h2 class="heading" style="text-align: center;">FACTURAS</h2> 
   <h3 class="heading" style="text-align: center;">{{nomusu}} </h3>

   <table id="tabla" class="table table-bordered row-border hover">
           <thead>
             <tr>
                <th >Fecha</th>
                <th >Serie</th>
                <th >Factura</th>
                <th >Doc.Asociado</th>
                <th >Fec.Asociado</th>
                <th >Ventas</th>
                <th >I.V.A.</th>
                <th >Total Neto</th>
         </tr>
           </thead> 
           <tbody>
             <tr *ngFor="let dato of datosTabla"> 
                <td [ngClass]="{'stotal': dato.facFech === 'TOTALES'}">{{ dato.facFech }}</td>
                <td >{{ dato.facSeri }}</td>
                <td *ngIf="dato.facNume > 0" [ngClass]="{'stotal': dato.facFech === 'TOTALES'}" class="numero">{{ dato.facNume }}</td> 
                <td *ngIf="dato.facNume === 0" >  </td> 
                <td >{{ dato.facDocu }}</td>
                <td >{{ dato.facFdoc }}</td>
                <td [ngClass]="{'stotal': dato.facFech === 'TOTALES'}" class="numero">{{ dato.facVtas | number: '.2'}}</td> 
                <td [ngClass]="{'stotal': dato.facFech === 'TOTALES'}" class="numero">{{ dato.facIvas | number: '.2'}}</td> 
                <td [ngClass]="{'stotal': dato.facFech === 'TOTALES'}" class="numero">{{ dato.facNeto | number: '.2'}}</td> 
         </tr> 
           </tbody> 
   </table>
 
</div>

 
